import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="site-footer-wrap">
      <section className="site-footer-main">
        <div className="footer-brand-panel">
          <div className="footer-logo-panel">
            <img src="/brand/relaygraph-logo.png" alt="RelayGraph" />
          </div>
        </div>

        <div className="footer-links-grid">
          <div>
            <h4>Explore</h4>
            <Link to="/">Home</Link>
            <Link to="/tools/wpa">WordPress Assessment</Link>
            <Link to="/tools/plugin-risk-mapper">Plugin Risk Mapper</Link>
          </div>
          <div>
            <h4>Company</h4>
            <a href="#about">About</a>
            <a href="#career">Career</a>
            <a href="#blogs">Blogs</a>
          </div>
          <div>
            <h4>Connect</h4>
            <a href="#linkedin">LinkedIn</a>
            <a href="#youtube">YouTube</a>
            <a href="#instagram">Instagram</a>
          </div>
        </div>
      </section>

      <section className="site-footer-legal">
        <a href="#privacy">Privacy Policy</a>
        <a href="#terms">Terms & Conditions</a>
        <a href="#cookies">Cookie Policy</a>
        <a href="#security">Security</a>
        <span>© {new Date().getFullYear()} RelayGraph. All rights reserved.</span>
      </section>
    </footer>
  );
}
